import React from 'react';
import GroupForm from './GroupForm';

const EditGroup = () => {
  return <GroupForm mode="edit" />;
};

export default EditGroup;
